import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerBankDetails() {
  const { baseurl, token, AdminId, setIsUnauthorised } =
    useGlobalContext();

  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  //  INSERT BANK DETAILS
  const insertVolunteerBankDetails = async (formData) => {
    try {
      setLoading(true);

      const payload = {
        adminId: AdminId || "",
        volunteerId: formData.volunteerId,
        email: formData.email,
        phone: formData.phone,
        bankName: formData.bankName,
        bankHolderName: formData.bankHolderName,
        accountNumber: formData.accountNumber,
        ifscCode: formData.ifscCode,
        aadharNumber: formData.aadharNumber,
        panNumber: formData.panNumber,
        primaryAccount: formData.primaryAccount || "Y",
      };

      const response = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/insertVolunteerBankDetails`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);
        return true;
      } else {
        toast.error(response.data?.responseMessage || "Failed to add bank details");
        return false;
      }
    } catch (error) {
      console.error("Insert Bank Error:", error);

      if (error.response?.status === 401) {
        setIsUnauthorised(true);
      }

      toast.error("Something went wrong");
      return false;
    } finally {
      setLoading(false);
    }
  };

  //  GET BANK DETAILS
 const getVolunteerBankDetails = async (volunteerId) => {
  try {
    setLoading(true);

    const response = await axios.post(
      `${baseurl}/api/VolunteerUser/v1.0/getVolunteerBankDetails`,
      {
        volunteerId: volunteerId,
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data?.responseCode === "00") {
      setBankDetails(response.data.data || []);
      return response.data.data || [];
    } else {
      setBankDetails([]);
      return [];
    }
  } catch (error) {
    console.error("Fetch Bank Error:", error);
    setBankDetails([]);
    return [];
  } finally {
    setLoading(false);
  }
};

  //  DELETE BANK DETAILS
  const deleteVolunteerBankDetails = async (bankId, volunteerId) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/deleteVolunteerBankDetails`,
        {
          adminId: AdminId || "",
          bankId: bankId,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);

        //  Refresh list automatically after delete
        if (volunteerId) {
          await getVolunteerBankDetails(volunteerId);
        }

        return true;
      } else {
        toast.error(response.data?.responseMessage || "Failed to delete bank details");
        return false;
      }
    } catch (error) {
      console.error("Delete Bank Error:", error);

      if (error.response?.status === 401) {
        setIsUnauthorised(true);
      }

      toast.error("Something went wrong while deleting");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    insertVolunteerBankDetails,
    getVolunteerBankDetails,
    deleteVolunteerBankDetails,
    bankDetails,
    loading,
  };
}
